"use client";

export const ErrorMessage = ({ error }: { error: string | Error | null }) => {
  if (!error) return null;

  return (
    <div className="text-sm text-red-500 mt-2 bg-red-100 p-1 rounded shadow-md pl-2">
      {error instanceof Error ? (
        <span>{error.message}</span>
      ) : (
        <span>{error}</span>
      )}  
    </div>
  );
}